import { useEffect, useRef } from "react";
import { useDragLayer, useDrop } from "react-dnd";
import { createPortal } from "react-dom";

export const ScrollTopDropTarget = (props: any) => {
    const scrollUp = () => {
        const el = props.listItemRef?.current;
        if (!el) return;
        el.scrollBy({ top: -10, behavior: "auto" });
    };

    const scrollTopDropRef = useRef(null);
    const [{ isOver }, drop] = useDrop({
        accept: "booking",
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
    });

    const topPosition =
        document?.getElementById("disposition_header_info")?.offsetTop || 0;

    const { isDragging } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging(),
    }));

    drop(scrollTopDropRef);

    useEffect(() => {
        if (!isOver) {
            return;
        }

        const intervalId = window.setInterval(() => {
            scrollUp();
        }, 16);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [isOver]);

    return createPortal(
            <div
                ref={scrollTopDropRef}
                style={{
                    position: "fixed",
                    //backgroundColor: "red",
                    zIndex: !isDragging ? -50 : 2010,
                    top: 206,
                    left: 0,
                    right: 0,
                    height: 60,
                    width: "100%",
                    // @ts-ignore
                }}
            />,
            document.getElementById("dispo_content"),
    );
};
